export default "__VITE_ASSET__809df7f5__"